import useSWRImmutable from 'swr/immutable';

import { publicConfig } from '@public-config';

import { CompanySubscription, CreditSubscription, DesignerSubscription, Subscription } from 'models';

import { ApiService } from 'services/ApiService';

const usePrices = () => {
    const swr = useSWRImmutable<Record<Subscription, { monthly: number; yearly: number }>>(
        `/subscriptions/prices`,
        () => ApiService.get(`${publicConfig.urls.api}/subscriptions/prices`),
    );

    return {
        ...swr,
        prices: swr.data || {
            [CompanySubscription.NONE]: { monthly: 0, yearly: 0 },
            [CompanySubscription.PREMIUM]: { monthly: 0, yearly: 0 },
            [DesignerSubscription.NONE]: { monthly: 0, yearly: 0 },
            [DesignerSubscription.STANDARD]: { monthly: 0, yearly: 0 },
            [CreditSubscription.NONE]: { monthly: 0, yearly: 0 },
            [CreditSubscription.STANDARD]: { monthly: 0, yearly: 0 },
        },
    };
};

export { usePrices };
